import React from 'react';
import MaterialDivider from 'material-ui/Divider';

const Divider = () => {
    return <MaterialDivider />;
};

export default Divider;



// WEBPACK FOOTER //
// ./src/components/ui/divider/Divider.js